enum BenchmarkingLineOfBusinessEnum {
  Medicare = 1,
  Marketplace = 2,
}

export { BenchmarkingLineOfBusinessEnum };
